import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Simplebar from 'components/Simplebar';
import React from 'react';

import { useAdvertisersDashboard } from '../AdvertisersDashboardContext';
import ExportAllButton from './ExportAllButton';
import SiteUniqueEngagementTable from './SiteUniqueEngagementTable';
import UniqueEngagementVsSiteChart from './UniqueEngagementVsSiteChart';

const TopPerformingSitesCard: React.FunctionComponent = () => {
  const { domainCompleteStats, domainTopSiteStats } = useAdvertisersDashboard();

  return (
    <Card>
      <CardHeader
        action={<ExportAllButton completeStats={domainCompleteStats} />}
        title="Top Performing Sources"
      />
      <CardContent component={Simplebar}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <SiteUniqueEngagementTable domainStats={domainTopSiteStats} />
          </Grid>
          <Grid item xs={12} lg={6}>
            <UniqueEngagementVsSiteChart domainStats={domainTopSiteStats} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TopPerformingSitesCard;
